/*
login.service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/services/login.service',[
    'jquery',
    'angular',
    '../module'
], function ($, angular, module) {
    'use strict';

    module.service('loginService', ['$window', '$rootScope', '$http', function ($window, $rootScope, $http) {

        var CID_TOKEN_KEY = 'cIdToken';
        var MAX_INACTIVE_TIME_KEY = 'maxInactiveTime';
        var EXPIRATION_TIME_KEY = 'expirationTime';
        var USER_NAME_KEY = 'loggedInUserName';
        var TOKEN_LAST_UPDATED_ON_KEY = 'tokenLastUpdatedOn';
        var SECOND_FACTOR_AUTHENTICATED_KEY = 'isSecondFactorAuthVerified';

        var DEFAULT_TOKEN_EXPIRY = 900000;
        var DEFAULT_MAX_INACTIVITY = 900000;
        var TOKEN_REFRESH_BUFFER = 60000;

        var now = function () {
            return new Date().getTime();
        };

        var removeFromLocalAndSessionStorage = function (key) {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        };

        var getCIdToken = function () {
            return localStorage.getItem(CID_TOKEN_KEY);
        };

        var getAuthenticationToken = function () {
            return 'Bearer ' + getCIdToken();
        };

        var setCIdToken = function (token) {
            sessionStorage.setItem(CID_TOKEN_KEY, token);
            localStorage.setItem(TOKEN_LAST_UPDATED_ON_KEY, now());
            $rootScope.$broadcast('notifyTokenRefreshSubscriber', token);
        };

        var getMaxInactiveTime = function () {
            return parseInt(localStorage.getItem(MAX_INACTIVE_TIME_KEY) || DEFAULT_MAX_INACTIVITY);
        };

        var getExpirationTime = function () {
            return parseInt(localStorage.getItem(EXPIRATION_TIME_KEY)) || DEFAULT_TOKEN_EXPIRY;
        };

        var invalidate = function () {
            removeFromLocalAndSessionStorage(CID_TOKEN_KEY);
            removeFromLocalAndSessionStorage(MAX_INACTIVE_TIME_KEY);
            removeFromLocalAndSessionStorage(EXPIRATION_TIME_KEY);
            removeFromLocalAndSessionStorage(USER_NAME_KEY);
            removeFromLocalAndSessionStorage(TOKEN_LAST_UPDATED_ON_KEY);

            sessionStorage.removeItem(SECOND_FACTOR_AUTHENTICATED_KEY);
            localStorage.clear();
        };

        var getLoginUrl = function () {
            var orgUrl = sessionStorage.getItem('orgUrl');
            return orgUrl ? '/' + orgUrl : '/login';
        };

        var doForcedLogout = function () {
            var token = getCIdToken();
            $http({
                method: 'POST',
                url: '/logout',
                data: $.param({ 'cIdToken': token }),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
            }).then(function () {
                invalidate();
                $window.location = getLoginUrl() + '?message=441';
            });
        };

        var getTokenLastUpdatedOn = function () {
            return parseInt(localStorage.getItem(TOKEN_LAST_UPDATED_ON_KEY));
        };

        var getTokenRefreshDuration = function () {
            return Math.max(getTokenLastUpdatedOn() + getExpirationTime() - TOKEN_REFRESH_BUFFER - now(), 0);
        };

        var isTokenRefreshed = function () {
            return getTokenRefreshDuration() > TOKEN_REFRESH_BUFFER;
        };

        var isTokenExpired = function () {
            return now() - getTokenLastUpdatedOn() > getExpirationTime();
        };

        var isOtherUserLoggedInToAnotherTab = function () {
            // if Not setted. consider the localStorage data.
            if (!sessionStorage.getItem(USER_NAME_KEY)) {
                sessionStorage.setItem(USER_NAME_KEY, localStorage.getItem(USER_NAME_KEY));
            }
            return sessionStorage.getItem(USER_NAME_KEY) !== localStorage.getItem(USER_NAME_KEY);
        };

        $window.addEventListener('storage', function (event) {
            if (event.key === null) {
                invalidate();
                $window.location = getLoginUrl() + '?message=440';
            }
        });

        this.getCIdToken = getCIdToken;
        this.getAuthenticationToken = getAuthenticationToken;
        this.setCIdToken = setCIdToken;

        this.getMaxInactiveTime = getMaxInactiveTime;

        this.getExpirationTime = getExpirationTime;

        this.invalidate = invalidate;

        this.getTokenRefreshDuration = getTokenRefreshDuration;
        this.isTokenRefreshed = isTokenRefreshed;
        this.isTokenExpired = isTokenExpired;
        this.isOtherUserLoggedInToAnotherTab = isOtherUserLoggedInToAnotherTab;
        this.logoutUser = doForcedLogout;
    }]);

    return module;
});

